// live "http://api.nourishwithsim.org/api/";
// dev "http://nwsapi.underdev.in/api/";
// test "https://testnwsapi.underdev.in/api/";

// live

export const localUrl = "https://api.nourishwithsim.org/api/";
// export const localUrl = "https://nwsapi.underdev.in/api/";
// export const localUrl = "https://testnwsapi.underdev.in/api/";
